import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider } from 'react-intl';
import store, { history } from './store';
import { Helmet } from 'react-helmet';
import { getSmallLogoImage } from 'services/axios';
import Routing from './components/Routing';
import ToastNotification from 'components/Common/ToastNotification';
import { addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import messages_en from 'intl/en.json';
import messages_de from 'intl/de.json';
import './style/default.less';
import './style/index.less';

addLocaleData([...locale_en, ...locale_de]);

const messages = {
  de: messages_de,
  en: messages_en,
};

//const language = navigator.language.split(/[-_]/)[0];  // language without region code

class App extends Component {
  render() {
    return (
      <IntlProvider locale="en" messages={messages['en']}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Helmet>
              <link rel="shortcut icon" href={getSmallLogoImage()} />
            </Helmet>
            <Routing getIntlMessages={namespace => messages[namespace]} />
            <ToastNotification />
          </ConnectedRouter>
        </Provider>
      </IntlProvider>
    );
  }
}

export default App;
